import RouteParser from 'route-parser';
import { decode, encode } from 'querystring';

export default class Route extends RouteParser {
  history = null;

  constructor(path, title, options={}) {
    super(path);
    const {color='primary', parentRoute=null, root=false, can} = options;
    this.root = root;
    this.parentRoute = parentRoute;
    this.title = title;
    this.color = color;
    this.can = can;
  }

  match(path) {
    return super.match(path);
  }

  matchMenu(routeParams, path){
    if(routeParams.root || !routeParams.parentRoute){
      return super.match(path);
    } else{
      return super.match(routeParams.parentRoute.spec);
    }
  }

  getParams() {
    return {
      ...this.getQuery(),
      ...this.match(this.history.location.pathname)
    };
  }

  getQuery() {
    return decode(this.history.location.search.slice(1));
  }

  setQuery(query, fixed_param=false) {
    if(fixed_param)
      return `${this.spec.replace(':id', fixed_param.id)}?${encode(query)}`;

    return `${this.spec}?${encode(query)}`;
  }
}
